import styled from 'styled-components';
import { absFull } from 'helpers/styles.js';
import { TopSixListContainer } from 'components/Global/TopSixList/styled.js';
import { EntityItemContainer } from 'components/Global/EntityItem/styled.js';
import { StyledTag } from 'components/Global/Tag/styled.js';

export const TopDataOverlay = styled.div`
  background: linear-gradient(62.13deg, #0C1520 25.53%, rgba(12, 31, 44, 0.7) 67.18%, rgba(63, 78, 90, 0.25) 92.45%);
  border-radius: 15px;
  padding: 40px;
  padding-bottom: 0;
  ${absFull()};
`;

export const TopDataContainer = styled.div`
  position: relative;
  height: 100%;
  display: inline-block;
  border-radius: 15px;
  width: 32%;
  background: ${({ bannerImageUrl }) => `url('${bannerImageUrl}') center center no-repeat`};
  background-size: cover;
  margin: 0 1%;
  text-align: left;

  ${TopSixListContainer} {
    padding: 0;
  }

  ${EntityItemContainer} {
    width: 100%;
  }

  ${StyledTag} {
    margin: 0;
  }
`;
